import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import { getGridTemplateColumnsForTasks } from '../utils';
import Cells from './Cells';
import styles from '../CalendarGrid.module.scss';

const CellWithMoreBtn = ({
  className,
  style,
  onClick,
  day,
  taskCount,
  visibleTaskCount = 6,
  onMoreBtnClick,
  children,
  zIndex,
  ...props
}) => {
  return (
    <Cells
      {...props}
      className={className}
      style={style}
      zIndex={zIndex}
      onClick={onClick}
    >
      {day && (
        <p
          className={cn(styles.date, {
            [styles.current]: day.isSame(moment(), 'day'),
          })}
        >
          {day.format('DD')}
        </p>
      )}

      <div
        className={styles.tasksWrapper}
        style={{
          gridTemplateColumns: getGridTemplateColumnsForTasks(taskCount),
        }}
      >
        {children}
      </div>
      {taskCount > visibleTaskCount && (
        <Button
          onClick={onMoreBtnClick}
          style={{ fontWeight: 700 }}
          type="link"
        >{`еще ${taskCount - visibleTaskCount}`}</Button>
      )}
    </Cells>
  );
};

export default CellWithMoreBtn;
